import Cookies from 'js-cookie';
import SignIn from '../components/Account/SignIn/SignIn';
import {   useNavigate } from "react-router-dom";
function ProtectedRoute(props) {
  const navigate = useNavigate();
  return (
    Cookies.get('token')?
    <> { props.component } </> : <><SignIn/></>  
  )
}
export default ProtectedRoute